import api, { handleResponse, handleError } from './api';

/**
 * Host-created promo codes on an event. Phase 1 of the promo code feature.
 *
 *   PromoCode {
 *     id, eventId, code, discountType ('percentage'|'fixed'),
 *     discountValue, maxUses (nullable), timesUsed, expiresAt (nullable), createdAt
 *   }
 */
const promoCodeService = {
  /** List codes the host has created for the given event (auth required). */
  async listForEvent(eventId) {
    try {
      const response = await api.get(`/events/${eventId}/promo-codes`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Create a code. `body` shape:
   *   { code, discountType: 'percentage'|'fixed', discountValue, maxUses?, expiresAt? }
   */
  async create(eventId, body) {
    try {
      const response = await api.post(`/events/${eventId}/promo-codes`, body);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async remove(promoCodeId) {
    try {
      const response = await api.delete(`/promo-codes/${promoCodeId}`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Public validation — works for guest checkout (anonymous) too.
   * Returns:
   *   { valid, reason?, promoCodeId?, discountType?, discountValue?,
   *     discountedPriceCents?, discountAmountCents? }
   */
  async validate({ eventId, code, quantity = 1 }) {
    try {
      const response = await api.post('/guest-checkout/validate-code', {
        eventId,
        code,
        quantity,
      });
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },
};

export default promoCodeService;
